import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { DocumentType } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { _mockDocumentType } from '../utils/documents.mock';

const getDocumentTypeById: QueryFunction<
  DocumentType,
  readonly ['/document-type', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockDocumentType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    documentType: DocumentType;
    nextCursor: string;
  }>(`/document-types/${queryKey[1]}`, {
    method: 'GET',
  });

  if (response.data?.documentType) {
    const docType = response.data.documentType;
    // Ensure extractionReviewThreshold has a default value if missing from API response
    return {
      ...docType,
      extractionReviewThreshold: docType.extractionReviewThreshold ?? 0,
      borrowerReviewThreshold: docType.borrowerReviewThreshold ?? 0,
      isClassificationThresholdUpdatedByUser:
        docType.isClassificationThresholdUpdatedByUser ?? false,
      isBorrowerThresholdUpdatedByUser:
        docType.isBorrowerThresholdUpdatedByUser ?? false,
    };
  }

  throw new Error('Failed to fetch document type by id');
};

export default getDocumentTypeById;

export { _mockDocumentType };
